// src/hooks/useDashboard.js - FIXED
import { useState, useEffect, useCallback, useRef } from 'react';
import { dashboardService } from '../services/dashboardService';
import { useCurrency } from '../context/CurrencyContext';

export const useDashboard = () => {
  const [walletData, setWalletData] = useState(null);
  const [trendingStocks, setTrendingStocks] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [investmentPlans, setInvestmentPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currency } = useCurrency();
  
  // Ref to prevent duplicate calls in StrictMode
  const initializedRef = useRef(false);
  const previousCurrencyRef = useRef(currency);

  // ✅ FIXED: Wrap in useCallback
  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [wallet, trending, portfolioData, plans] = await Promise.all([
        dashboardService.getWalletBalance(),
        dashboardService.getTrendingStocks(),
        dashboardService.getPortfolio(),
        dashboardService.getInvestmentPlans()
      ]);

      setWalletData(wallet);
      setTrendingStocks(trending);
      setPortfolio(portfolioData);
      setInvestmentPlans(plans);

    } catch (err) {
      setError(err.message);
      console.error('Dashboard data fetch error:', err);
    } finally {
      setLoading(false);
    }
  }, []); // ✅ Empty deps - only currency should trigger refetch

  useEffect(() => {
    // Prevent duplicate initial call in StrictMode
    if (!initializedRef.current) {
      initializedRef.current = true;
      fetchDashboardData();
      return;
    }
    
    // Only refetch if currency actually changed
    if (previousCurrencyRef.current !== currency) {
      previousCurrencyRef.current = currency;
      fetchDashboardData();
    }
  }, [currency, fetchDashboardData]); // ✅ Now safe to include

  return {
    walletData,
    trendingStocks,
    portfolio,
    investmentPlans,
    loading,
    error,
    refetch: fetchDashboardData
  };
};